import { render, staticRenderFns } from "./ModalSolicitarVaga.vue?vue&type=template&id=c3c0bed6"
import script from "./ModalSolicitarVaga.vue?vue&type=script&lang=js"
export * from "./ModalSolicitarVaga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports